// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global */
body:has(div.form-camera) {
    background-color: #666666;
}

body:has(div.form-summary) {
    background-color: #BA9BC9;
}

.page {
    width: 80%;
    margin-left: 10%;
    margin-bottom: 50px;
}

.page-form {
    margin: auto;
    max-width: 700px;
}

.page-summary {
    width: 80%;
    margin-left: 10%;
}

.page-summary > p {
    text-align: left;
}

.hidden {
    display: none !important;
}

.heading {
    padding-top: 10px;
    font-size: 34px;
    font-family: 'PingFangTC-Semibold';
}

.separate-line {
    border: 1px solid #FFFFFF;
    border-radius: 2px;
    width: 10%;
    margin-bottom: 30px;
}

.sub-heading {
    font-size: 20px;
    font-family: 'PingFangTC-Regular';
}

/* Header */
.header {
    background-color: #4ACACF;
    height: 100px;
}

.header-introduction {
    background-color: #FFFFFF;
    height: 150px;
    align-items: center;
}

.header-camera {
    background-color: #666666;
    height: 100px;
}

.header-summary {
    background-color: #BA9BC9;
}

.logo {
    height: 75px;
    display: flex;
    justify-content: flex-start;
    padding-left: 10%;
}

.logo-box{
    width: 100vw;
    display: flex;
    justify-content: center;
}

.logo-white {
    height: 113px;
    padding-left: 0px;
}

.lang {
    display: flex;
    justify-content: flex-end;
    padding-right: 10%;
    color: #000000;
}

.lang-options {
    text-decoration: none;
    color: #000000;
    font-family: 'PingFangTC-Regular';
    font-weight: 600;
}

.step-tab {
    height: 40px !important;
    margin: 5px !important;
    border: 2px solid #FFFFFF !important;
    color: #FFFFFF !important;
    background-color: transparent !important;
}

.step-tab-content {
    display: inline-flex;
    align-items: center;
    font-size: 20px;
    font-family: 'PingFangTC-Semibold';
}

.step-tab-number {
    border: 4px solid #FFFFFF;
    border-radius: 30px;
    width: 30px;
    height: 30px;
    margin-left: -18px;
    margin-right: 18px;
    line-height: 30px;
    background-color: #4ACACF;
}

.chosen-tab {
    color: #4ACACF !important;
    background-color: #FFFFFF !important;
}

.chosen-tab-camera {
    color: #666666 !important;
    background-color: #FFFFFF !important;
}

.chosen-tab-camera > .step-tab-content > .step-tab-text {
    color: #4ACACF;
}

.step-tab-number {
    color: #FFFFFF;
    background-color: #4ACACF;
}

/* Footer */
.footer-disclaimer {
    margin: auto;
    margin-top: 50px;
    text-align: left;
    width: 80%;
    max-width: 700px;
}

.disclaimer-heading {
    font-family: 'PingFangTC-Semibold';
}

.disclaimer-content {
    font-family: 'PingFangTC-Regular';
}

.copyright {
    margin-top: 50px;
    height: 100px;
    font-size: 16px;
    font-family: 'PingFangTC-Regular';
}

/* Introduction */
.sub-heading-special {
    font-size: 50px;
    font-family: 'PingFangTC-Regular';
}

.steps {
    margin-left: 10%;
    width: 80%;
    position: relative;
}

.steps-image {
    width: 100%;
    max-width: 600px;
}

.steps-text {
    color: #666666;
    font-size: 20px;
    font-family: 'PingFangTC-Semibold';
    white-space: pre-line;
    position: absolute;
    top: 50%;
    right: 50%;
    transform: translate(66%, -50%);
    min-width: 220px;
}

.footer-button {
    background-color: transparent !important;
    border: 4px solid #FFFFFF !important;
    max-width: 90%;
    margin-top: 50px !important;
}

.footer-button-text {
    width: 320px;
    color: #FFFFFF;
    font-size: 24px;
}

/* Information */
.information-box {
    margin: auto;
    display: flex;
    width: 520px;
    max-width: 90%;
}

.information-textbox {
    background-color: #FFFFFF !important;
    width: 520px;
    max-width: 90%;
    border-radius: 10px;
    margin: 20px 0 !important;
}

.reminder {
    font-size: 16px;
    font-family: 'PingFangTC-Medium';
}

.information-checkbox { /* IE */ /* FF */ /* Safari and Chrome */ /* Opera */
    transform: scale(2);
    padding: 10px;
    color: #FFFFFF !important;
}

.information-tnc {
    font-size: 14px;
    display: flex;
    justify-self: center;
    text-align: left;
    margin-left: 5px;
}

/* Questionnaire */
.questionnaire-box {
    margin: auto;
    width: 100%;
}

.questionnaire-question {
    color: #000000;
    font-size: 20px;
    font-family: 'PingFangTC-Semibold';
    text-align: left;
    margin-top: 50px;
}

.questionnaire-option {
    color: #000000;
    font-size: 20px;
    font-family: 'PingFangTC-Medium';
    background-color: #FFFFFF;
    width: 100%;
    min-height: 50px;
    border-radius: 50px;
    margin-left: 0px !important;
    border: 2px solid transparent;
}

.questionnaire-option > span {
    margin: auto;
    overflow: hidden;
}

.questionnaire-option:has(span.Mui-checked) {
    border: 2px solid red;
}

.questionnaire-option > .MuiCheckbox-root {
    display: none !important;
}

.questionnaire-option:has(img) {
    border-radius: 16px;
}

.questionnaire-option-image {
    max-height: 170px;
    max-width: 100%;
}

.questionnaire-option-text {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    height: 67px;
}

.questionnaire-textbox {
    font-family: 'PingFangTC-Medium';
    background-color: #FFFFFF;
    width: 100%;
    min-height: 50px;
    border-radius: 50px;
}

.questionnaire-option > .MuiRadio-root {
    display: none !important;
}


.MuiOutlinedInput-notchedOutline {
    border: none !important;
}

.remark-multiple {
    font-size: 15px;
    font-family: 'PingFangTC-Medium';
}

/* Camera */
.camera-instructions {
    max-width: 600px;
    border-radius: 10px;
    background-color: #999999;
    margin: 30px auto;
    padding: 10px;
    display: flex;
}

.camera-instructions-image {
    width: 30%;
    border-radius: 10px;
    margin-right: 10px;
}

@media (max-width: 600px) {
    .camera-instructions {
        max-width: 600px;
        border-radius: 10px;
        background-color: #999999;
        margin: 30px auto;
        padding: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .camera-instructions-image {
        width: 50%;
        border-radius: 10px;
        margin-right: 10px;
    }
}


.camera-instructions-text {
    text-align: left;
    margin-top: 5%;
    margin-left: 0;
    white-space: pre-line;
}

.camera-container {
    width: 80%;
    max-width: 720px;
    aspect-ratio: 1;
    border-radius: 40px;
    margin: auto;
    overflow: hidden;
    position: relative;
    border: 1px solid #FFFFFF;
}

.no-border {
    border: none;
}

.camera-webcam {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.camera-filter {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
}

.photo-taken-container {
    width: 80%;
    max-width: 720px;
    margin: auto;
    margin-top: 30px;
}

.photo-taken-div {
    width: 25%;
    display: inline-flex;
}

.photo-taken-div-preview {
    width: 30%;
    display: block;
    margin: auto;
    margin-bottom: 30px;
}

.photo-taken {
    width: 85%;
    aspect-ratio: 1;
    border-radius: 15px;
    background-color: #4D4D4D;
    margin: auto;
    position: relative;
    overflow: hidden;
}

.current-photo {
    border: 3px solid #4ACACF;
}

.taken-image {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
}

.taken-icon {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
}

.photo-taken-div-preview > .photo-taken > .taken-icon {
    transform: scale(0.6);
}

.capture-button {
    background-color: #4ACACF !important;
    max-width: 90%;
    margin-top: 50px !important;
}

.capture-button-text {
    width: 320px;
    color: #FFFFFF;
    font-size: 24px;
}

/* .icon-container {
    width: 80%;
    max-width: 720px;
    margin: auto;
    margin-top: 50px;
    display: flex;
    justify-content: space-between;
} */

.icon {
    margin-top: 30px;
    width: 150px;
    max-width: 33%;
    cursor: pointer;
}

.retake-button {
    color: #FFFFFF;
    font-size: 24px;
    text-decoration: underline;
    display: block;
    margin-top: 20px;
    cursor: pointer;
}

/* Summary */
.summary-smile-icon-box{
    width: 100%;
    display: flex;
    justify-content: center;
}

.summary-smile-icon {
    width: 400px;
}

.summary-heading-box{
    display: flex;
    flex-direction: column;
}

.summary-heading {
    font-size: 26px;
    font-family: 'PingFangTC-Semibold';
    white-space: pre-line;
    margin: 0;
    line-height: 300%;
}

.summary-sub-heading {
    font-size: 20px;
    font-family: 'PingFangTC-Regular';
    margin-bottom: 40px;
    line-height: 250%;
}

.whatsapp-icon {
    font-size: 45px !important;
}

.whatsapp-button {
    background-color: #FFFFFF !important;
    max-width: 90% !important;
    min-height: 70px !important;
    border-radius: 35px !important;
    margin-top: 40px !important;
}

.whatsapp-button-text {
    width: 320px;
    color: #BA9BC9;
    font-size: 24px;
    font-family: 'PingFangTC-Semibold';
    display: flex;
    align-items: center;
    justify-content: center;
}

.more-detail-button {
    background-color: transparent !important;
    border: 4px solid #FFFFFF !important;
    max-width: 90% !important;
    min-height: 70px !important;
    border-radius: 35px !important;
    margin-top: 30px !important;
    margin-bottom: 40px !important;
}

.more-detail-button-text {
    width: 320px;
    color: #FFFFFF;
    font-size: 24px;
}

.summary-footer {
    text-align: center;
    margin-top: 50px;
}

.summary-footer-heading {
    font-size: 20px;
    font-family: 'PingFangTC-Semibold';
}

.summary-footer-content {
    font-size: 20px;
    font-family: 'PingFangTC-Regular';
    white-space: pre-line;
    line-height: 200%;
}

/* Login */
.login-form {
    position: relative;
    height: 250px;
}

.login-form-username {
    width: 100%;
    max-width: 400px;
    position: absolute !important;
    top: 20%;
    left: 50%;
    transform: translateX(-50%);
}

.login-form-password {
    width: 100%;
    max-width: 400px;
    position: absolute !important;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.login-form-submit {
    width: 100% !important;
    max-width: 200px !important;
    position: absolute !important;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
}

/* Submission */
.submission-container{
    display: flex;
    flex-direction: column;
    background-color: #FFFFFF;
}

.logout-button {
    color: #FFFFFF !important;
    background-color: #4ACACF !important;
    :hover {
        color: #858e96 !important;
    }
}

.export-button {
    padding: 0px;
    width: 34px;
    color: #858e96;
}

/* Detail */
.detail-page {
    margin-top: 30px;
    margin-left: 10%;
    width: 80%;
}

.back-button {
    position: fixed;
    left: 5%;
    top: 35px;
    cursor: pointer;
}

.detail-grid {
    text-align: left;
}

.detail-subtitle {
    font-size: 26px;
    font-weight: 600;
}

.detail-image {
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/styles/default.css"],"names":[],"mappings":"AAAA,WAAW;AACX;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iCAAiC;AACrC;;AAEA,WAAW;AACX;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,oCAAoC;IACpC,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA,WAAW;AACX;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,iCAAiC;AACrC;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kCAAkC;IAClC,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;IACpC,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gCAAgC;AACpC;;AAEA,wBAC6B,OAAO,EACN,OAAO,EACJ,sBAAsB,EAC3B,UAAU;IAClC,mBAAmB;IACnB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,aAAa;IACb,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kCAAkC;IAClC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gCAAgC;IAChC,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;;AAGA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gCAAgC;AACpC;;AAEA,WAAW;AACX;IACI,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;QACI,gBAAgB;QAChB,mBAAmB;QACnB,yBAAyB;QACzB,iBAAiB;QACjB,aAAa;QACb,aAAa;QACb,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,mBAAmB;QACnB,kBAAkB;IACtB;AACJ;;;AAGA;IACI,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;AACb;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;;;;;;;GAOG;;AAEH;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA,YAAY;AACZ;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,qBAAqB;IACrB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iCAAiC;IACjC,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,2BAA2B;IAC3B,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;IACpC,yBAAyB;IACzB,2BAA2B;IAC3B,8BAA8B;IAC9B,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,iCAAiC;IACjC,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA,UAAU;AACV;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,6BAA6B;IAC7B,QAAQ;IACR,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,6BAA6B;IAC7B,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,6BAA6B;IAC7B,SAAS;IACT,SAAS;IACT,2BAA2B;AAC/B;;AAEA,eAAe;AACf;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;IACpC;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;AAClB;;AAEA,WAAW;AACX;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf","sourcesContent":["/* Global */\nbody:has(div.form-camera) {\n    background-color: #666666;\n}\n\nbody:has(div.form-summary) {\n    background-color: #BA9BC9;\n}\n\n.page {\n    width: 80%;\n    margin-left: 10%;\n    margin-bottom: 50px;\n}\n\n.page-form {\n    margin: auto;\n    max-width: 700px;\n}\n\n.page-summary {\n    width: 80%;\n    margin-left: 10%;\n}\n\n.page-summary > p {\n    text-align: left;\n}\n\n.hidden {\n    display: none !important;\n}\n\n.heading {\n    padding-top: 10px;\n    font-size: 34px;\n    font-family: 'PingFangTC-Semibold';\n}\n\n.separate-line {\n    border: 1px solid #FFFFFF;\n    border-radius: 2px;\n    width: 10%;\n    margin-bottom: 30px;\n}\n\n.sub-heading {\n    font-size: 20px;\n    font-family: 'PingFangTC-Regular';\n}\n\n/* Header */\n.header {\n    background-color: #4ACACF;\n    height: 100px;\n}\n\n.header-introduction {\n    background-color: #FFFFFF;\n    height: 150px;\n    align-items: center;\n}\n\n.header-camera {\n    background-color: #666666;\n    height: 100px;\n}\n\n.header-summary {\n    background-color: #BA9BC9;\n}\n\n.logo {\n    height: 75px;\n    display: flex;\n    justify-content: flex-start;\n    padding-left: 10%;\n}\n\n.logo-box{\n    width: 100vw;\n    display: flex;\n    justify-content: center;\n}\n\n.logo-white {\n    height: 113px;\n    padding-left: 0px;\n}\n\n.lang {\n    display: flex;\n    justify-content: flex-end;\n    padding-right: 10%;\n    color: #000000;\n}\n\n.lang-options {\n    text-decoration: none;\n    color: #000000;\n    font-family: 'PingFangTC-Regular';\n    font-weight: 600;\n}\n\n.step-tab {\n    height: 40px !important;\n    margin: 5px !important;\n    border: 2px solid #FFFFFF !important;\n    color: #FFFFFF !important;\n    background-color: transparent !important;\n}\n\n.step-tab-content {\n    display: inline-flex;\n    align-items: center;\n    font-size: 20px;\n    font-family: 'PingFangTC-Semibold';\n}\n\n.step-tab-number {\n    border: 4px solid #FFFFFF;\n    border-radius: 30px;\n    width: 30px;\n    height: 30px;\n    margin-left: -18px;\n    margin-right: 18px;\n    line-height: 30px;\n    background-color: #4ACACF;\n}\n\n.chosen-tab {\n    color: #4ACACF !important;\n    background-color: #FFFFFF !important;\n}\n\n.chosen-tab-camera {\n    color: #666666 !important;\n    background-color: #FFFFFF !important;\n}\n\n.chosen-tab-camera > .step-tab-content > .step-tab-text {\n    color: #4ACACF;\n}\n\n.step-tab-number {\n    color: #FFFFFF;\n    background-color: #4ACACF;\n}\n\n/* Footer */\n.footer-disclaimer {\n    margin: auto;\n    margin-top: 50px;\n    text-align: left;\n    width: 80%;\n    max-width: 700px;\n}\n\n.disclaimer-heading {\n    font-family: 'PingFangTC-Semibold';\n}\n\n.disclaimer-content {\n    font-family: 'PingFangTC-Regular';\n}\n\n.copyright {\n    margin-top: 50px;\n    height: 100px;\n    font-size: 16px;\n    font-family: 'PingFangTC-Regular';\n}\n\n/* Introduction */\n.sub-heading-special {\n    font-size: 50px;\n    font-family: 'PingFangTC-Regular';\n}\n\n.steps {\n    margin-left: 10%;\n    width: 80%;\n    position: relative;\n}\n\n.steps-image {\n    width: 100%;\n    max-width: 600px;\n}\n\n.steps-text {\n    color: #666666;\n    font-size: 20px;\n    font-family: 'PingFangTC-Semibold';\n    white-space: pre-line;\n    position: absolute;\n    top: 50%;\n    right: 50%;\n    transform: translate(66%, -50%);\n    min-width: 220px;\n}\n\n.footer-button {\n    background-color: transparent !important;\n    border: 4px solid #FFFFFF !important;\n    max-width: 90%;\n    margin-top: 50px !important;\n}\n\n.footer-button-text {\n    width: 320px;\n    color: #FFFFFF;\n    font-size: 24px;\n}\n\n/* Information */\n.information-box {\n    margin: auto;\n    display: flex;\n    width: 520px;\n    max-width: 90%;\n}\n\n.information-textbox {\n    background-color: #FFFFFF !important;\n    width: 520px;\n    max-width: 90%;\n    border-radius: 10px;\n    margin: 20px 0 !important;\n}\n\n.reminder {\n    font-size: 16px;\n    font-family: 'PingFangTC-Medium';\n}\n\n.information-checkbox {\n    -ms-transform: scale(2); /* IE */\n    -moz-transform: scale(2); /* FF */\n    -webkit-transform: scale(2); /* Safari and Chrome */\n    -o-transform: scale(2); /* Opera */\n    transform: scale(2);\n    padding: 10px;\n    color: #FFFFFF !important;\n}\n\n.information-tnc {\n    font-size: 14px;\n    display: flex;\n    justify-self: center;\n    text-align: left;\n    margin-left: 5px;\n}\n\n/* Questionnaire */\n.questionnaire-box {\n    margin: auto;\n    width: 100%;\n}\n\n.questionnaire-question {\n    color: #000000;\n    font-size: 20px;\n    font-family: 'PingFangTC-Semibold';\n    text-align: left;\n    margin-top: 50px;\n}\n\n.questionnaire-option {\n    color: #000000;\n    font-size: 20px;\n    font-family: 'PingFangTC-Medium';\n    background-color: #FFFFFF;\n    width: 100%;\n    min-height: 50px;\n    border-radius: 50px;\n    margin-left: 0px !important;\n    border: 2px solid transparent;\n}\n\n.questionnaire-option > span {\n    margin: auto;\n    overflow: hidden;\n}\n\n.questionnaire-option:has(span.Mui-checked) {\n    border: 2px solid red;\n}\n\n.questionnaire-option > .MuiCheckbox-root {\n    display: none !important;\n}\n\n.questionnaire-option:has(img) {\n    border-radius: 16px;\n}\n\n.questionnaire-option-image {\n    max-height: 170px;\n    max-width: 100%;\n}\n\n.questionnaire-option-text {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 10px;\n    height: 67px;\n}\n\n.questionnaire-textbox {\n    font-family: 'PingFangTC-Medium';\n    background-color: #FFFFFF;\n    width: 100%;\n    min-height: 50px;\n    border-radius: 50px;\n}\n\n.questionnaire-option > .MuiRadio-root {\n    display: none !important;\n}\n\n\n.MuiOutlinedInput-notchedOutline {\n    border: none !important;\n}\n\n.remark-multiple {\n    font-size: 15px;\n    font-family: 'PingFangTC-Medium';\n}\n\n/* Camera */\n.camera-instructions {\n    max-width: 600px;\n    border-radius: 10px;\n    background-color: #999999;\n    margin: 30px auto;\n    padding: 10px;\n    display: flex;\n}\n\n.camera-instructions-image {\n    width: 30%;\n    border-radius: 10px;\n    margin-right: 10px;\n}\n\n@media (max-width: 600px) {\n    .camera-instructions {\n        max-width: 600px;\n        border-radius: 10px;\n        background-color: #999999;\n        margin: 30px auto;\n        padding: 10px;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .camera-instructions-image {\n        width: 50%;\n        border-radius: 10px;\n        margin-right: 10px;\n    }\n}\n\n\n.camera-instructions-text {\n    text-align: left;\n    margin-top: 5%;\n    margin-left: 0;\n    white-space: pre-line;\n}\n\n.camera-container {\n    width: 80%;\n    max-width: 720px;\n    aspect-ratio: 1;\n    border-radius: 40px;\n    margin: auto;\n    overflow: hidden;\n    position: relative;\n    border: 1px solid #FFFFFF;\n}\n\n.no-border {\n    border: none;\n}\n\n.camera-webcam {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.camera-filter {\n    width: 100%;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n}\n\n.photo-taken-container {\n    width: 80%;\n    max-width: 720px;\n    margin: auto;\n    margin-top: 30px;\n}\n\n.photo-taken-div {\n    width: 25%;\n    display: inline-flex;\n}\n\n.photo-taken-div-preview {\n    width: 30%;\n    display: block;\n    margin: auto;\n    margin-bottom: 30px;\n}\n\n.photo-taken {\n    width: 85%;\n    aspect-ratio: 1;\n    border-radius: 15px;\n    background-color: #4D4D4D;\n    margin: auto;\n    position: relative;\n    overflow: hidden;\n}\n\n.current-photo {\n    border: 3px solid #4ACACF;\n}\n\n.taken-image {\n    width: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.taken-icon {\n    width: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.photo-taken-div-preview > .photo-taken > .taken-icon {\n    transform: scale(0.6);\n}\n\n.capture-button {\n    background-color: #4ACACF !important;\n    max-width: 90%;\n    margin-top: 50px !important;\n}\n\n.capture-button-text {\n    width: 320px;\n    color: #FFFFFF;\n    font-size: 24px;\n}\n\n/* .icon-container {\n    width: 80%;\n    max-width: 720px;\n    margin: auto;\n    margin-top: 50px;\n    display: flex;\n    justify-content: space-between;\n} */\n\n.icon {\n    margin-top: 30px;\n    width: 150px;\n    max-width: 33%;\n    cursor: pointer;\n}\n\n.retake-button {\n    color: #FFFFFF;\n    font-size: 24px;\n    text-decoration: underline;\n    display: block;\n    margin-top: 20px;\n    cursor: pointer;\n}\n\n/* Summary */\n.summary-smile-icon-box{\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n\n.summary-smile-icon {\n    width: 400px;\n}\n\n.summary-heading-box{\n    display: flex;\n    flex-direction: column;\n}\n\n.summary-heading {\n    font-size: 26px;\n    font-family: 'PingFangTC-Semibold';\n    white-space: pre-line;\n    margin: 0;\n    line-height: 300%;\n}\n\n.summary-sub-heading {\n    font-size: 20px;\n    font-family: 'PingFangTC-Regular';\n    margin-bottom: 40px;\n    line-height: 250%;\n}\n\n.whatsapp-icon {\n    font-size: 45px !important;\n}\n\n.whatsapp-button {\n    background-color: #FFFFFF !important;\n    max-width: 90% !important;\n    min-height: 70px !important;\n    border-radius: 35px !important;\n    margin-top: 40px !important;\n}\n\n.whatsapp-button-text {\n    width: 320px;\n    color: #BA9BC9;\n    font-size: 24px;\n    font-family: 'PingFangTC-Semibold';\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.more-detail-button {\n    background-color: transparent !important;\n    border: 4px solid #FFFFFF !important;\n    max-width: 90% !important;\n    min-height: 70px !important;\n    border-radius: 35px !important;\n    margin-top: 30px !important;\n    margin-bottom: 40px !important;\n}\n\n.more-detail-button-text {\n    width: 320px;\n    color: #FFFFFF;\n    font-size: 24px;\n}\n\n.summary-footer {\n    text-align: center;\n    margin-top: 50px;\n}\n\n.summary-footer-heading {\n    font-size: 20px;\n    font-family: 'PingFangTC-Semibold';\n}\n\n.summary-footer-content {\n    font-size: 20px;\n    font-family: 'PingFangTC-Regular';\n    white-space: pre-line;\n    line-height: 200%;\n}\n\n/* Login */\n.login-form {\n    position: relative;\n    height: 250px;\n}\n\n.login-form-username {\n    width: 100%;\n    max-width: 400px;\n    position: absolute !important;\n    top: 20%;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.login-form-password {\n    width: 100%;\n    max-width: 400px;\n    position: absolute !important;\n    top: 60%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.login-form-submit {\n    width: 100% !important;\n    max-width: 200px !important;\n    position: absolute !important;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n/* Submission */\n.submission-container{\n    display: flex;\n    flex-direction: column;\n    background-color: #FFFFFF;\n}\n\n.logout-button {\n    color: #FFFFFF !important;\n    background-color: #4ACACF !important;\n    :hover {\n        color: #858e96 !important;\n    }\n}\n\n.export-button {\n    padding: 0px;\n    width: 34px;\n    color: #858e96;\n}\n\n/* Detail */\n.detail-page {\n    margin-top: 30px;\n    margin-left: 10%;\n    width: 80%;\n}\n\n.back-button {\n    position: fixed;\n    left: 5%;\n    top: 35px;\n    cursor: pointer;\n}\n\n.detail-grid {\n    text-align: left;\n}\n\n.detail-subtitle {\n    font-size: 26px;\n    font-weight: 600;\n}\n\n.detail-image {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
